import { IStyle, classNamesFunction } from '@fluentui/react';
import { IThemedProp } from './themesUI';

export interface IRequestCardStyles {
  sectionContainer: IStyle;
  cursorPointer: IStyle;
  contentContainerBase: IStyle;
  contentContainerPrimary: IStyle;
  contentContainerSecondary: IStyle;
  contentPrimary: IStyle;
  stateBullet: IStyle;
  descriptionSpanContainer: IStyle;
}

export const getRequestCardStyles = (_props: IThemedProp): IRequestCardStyles => {
  return {
    sectionContainer: {
      marginBottom: '24px',
      fontSize: '14px',
    },
    cursorPointer: {
      cursor: 'pointer',
    },
    contentContainerBase: {
      marginLeft: '40px',
      marginBottom: '8px',
      // justifyContent: contentSecondaryWidth ? 'space-between' : 'unset',
      flexWrap: 'nowrap',
      width: 'calc(100% - 34px)',
    },
    contentContainerPrimary: {
      display: 'flex',
      alignItems: 'center',
    },
    contentContainerSecondary: {
      display: 'block',
      alignItems: 'inherit',
    },
    contentPrimary: {
      // flexGrow: 1,
      marginRight: '5px',
    },
    stateBullet: {
      marginLeft: '5px',
      marginRight: '5px',
    },
    descriptionSpanContainer: {
      maxHeight: '40px',
    },
  };
};

export const getRequestCardClassNames = classNamesFunction<{}, IRequestCardStyles>();
